import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import {Storage } from '@ionic/storage';

import * as page from '../pages/pages';
import { AuthorisedHomePage, LoginPage, HomePage } from '../pages/pages';

@Component({
	templateUrl: 'app.html'
})

export class MyApp {
	@ViewChild(Nav) nav: Nav;

	rootPage: any = page.HomePage;
	showLogout: boolean = false;

	pages: Array<{ title: string, icon:string, component: any }>;

	constructor(
		public storage: Storage,
		public platform: Platform, 
		public statusBar: StatusBar,
		public splashScreen: SplashScreen,
		private loadingCtrl: LoadingController,
		private iab: InAppBrowser) {
		this.initializeApp();

		// this.pages = [
		// 	{ title: 'Home', icon: 'home', component: page.HomePage },
		// 	{ title: 'eCom Conference 2018', icon: 'users', component: page.ConferencePage },
		// 	{ title: 'Case Studies', icon: 'tasks', component: page.TopicsPage },
		// 	{ title: 'Recent Videos', icon: 'video-camera', component: page.VideoPage },
		// 	{ title: 'Visit Website', icon: 'info-circle', component: null }
		// ];

	}

	initializeApp() {
		this.platform.ready().then(() => {
			// Okay, so the platform is ready and our plugins are available.
			// Here you can do any higher level native things you might need.
			this.statusBar.styleDefault();
			this.splashScreen.hide();

			//Set root page
			this.storage.get('accessToken').then(data => {
				if(data != null && data != undefined){
					this.rootPage = AuthorisedHomePage;
					this.showLogout = true;
				}
				else{
					this.rootPage = HomePage;
				}
			});
		});
	}

	logout() {
		let loader = this.loadingCtrl.create();
		loader.present().then(() => {
			this.storage.remove('username');
			this.storage.remove('accessToken');
			this.storage.remove('currentRole');
			this.storage.remove('userId');
			this.storage.remove('name');
			this.nav.setRoot(HomePage);
			this.showLogout = false;
			loader.dismiss().catch(err => console.log(err));
		}).catch(
			function () {
				loader.dismiss().catch(err => console.log(err))
				this.showLogout = false;
			});
	}

	openPage(page) {
		if (page.title == "Visit Website"){
			this.iab.create("http://ecomscotland.com/", '_system');
		}else{
			this.nav.push(page.component);
		}
	}
	
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts